
import styles from "./listView.module.scss";
import React from "react";
import PropTypes from 'prop-types';


const ListViewContainer = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={`${styles.listViewContainer} ${className}`}
      {...props}
    />
))
ListViewContainer.displayName = "ListViewContainer";
ListViewContainer.propTypes = {
  className: PropTypes.string
};

const ListViewItem = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={`${styles.listViewItem} ${className}`}
    {...props}
  />
))
ListViewItem.displayName = "ListViewItem";
ListViewItem.propTypes = {
  className: PropTypes.string
};


const ListViewItemHeader = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={`${styles.listViewHeaderItem} ${className}`}
    {...props}
  />
))
ListViewItemHeader.displayName = "ListViewItemHeader";
ListViewItemHeader.propTypes = {
  className: PropTypes.string
};


const ListViewItemHeaderContent = React.forwardRef<
HTMLDivElement,
React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
<div
  ref={ref}
  className={`${styles.listViewItemHeaderContent} ${className}`}
  {...props}
/>
))
ListViewItemHeaderContent.displayName = "ListViewItemHeaderContent";
ListViewItemHeaderContent.propTypes = {
  className: PropTypes.string
};


const ListViewTitle = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={`${styles.listViewTitle} ${className}`}
    {...props}
  />
))
ListViewTitle.displayName = "ListViewTitle";
ListViewTitle.propTypes = {
  className: PropTypes.string
};


const ListViewDescription = React.forwardRef<
  HTMLSpanElement,
  React.HTMLAttributes<HTMLSpanElement>
>(({ className, ...props }, ref) => (
  <span
    ref={ref}
    className={`${styles.listViewDescription} ${className}`}
    {...props}
  />
))
ListViewDescription.displayName = "ListViewDescription";
ListViewDescription.propTypes = {
  className: PropTypes.string
};

const ListViewActions = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div ref={ref} className={`${styles.listViewActions} ${className}`} {...props} />
))
ListViewActions.displayName = "ListViewActions";
ListViewActions.propTypes = {
  className: PropTypes.string
};

const ListViewLeftActions = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div ref={ref} className={`${styles.listViewActions} ${className}`} {...props} />
))
ListViewLeftActions.displayName = "ListViewLeftActions";
ListViewLeftActions.propTypes = {
  className: PropTypes.string
};

const ListViewContent = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div ref={ref} className={`${styles.listViewContent} ${className}`} {...props} />
))
ListViewContent.displayName = "ListViewContent";
ListViewContent.propTypes = {
  className: PropTypes.string
};

const ListViewContentItem = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div ref={ref} className={`${styles.listViewContentItem} ${className}`} {...props} />
))
ListViewContentItem.displayName = "ListViewContentItem";
ListViewContentItem.propTypes = {
  className: PropTypes.string
};

const ListViewContentItemTitle = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={`${styles.listViewContentItemTitle} ${className}`}
    {...props}
  />
))
ListViewContentItemTitle.displayName = "ListViewContentItemTitle";
ListViewContentItemTitle.propTypes = {
  className: PropTypes.string
};

const ListViewContentItemDescription = React.forwardRef<
  HTMLSpanElement,
  React.HTMLAttributes<HTMLSpanElement>
>(({ className, ...props }, ref) => (
  <span
    ref={ref}
    className={`${styles.listViewContentItemDescription} ${className}`}
    {...props}
  />
))
ListViewContentItemDescription.displayName = "ListViewContentItemDescription";
ListViewContentItemDescription.propTypes = {
  className: PropTypes.string
};


const ListView = {
    Container: ListViewContainer,
    Item: ListViewItem,
    Header: ListViewItemHeader,
    Headline: ListViewItemHeaderContent,
    Title: ListViewTitle,
    Description: ListViewDescription,
    Actions: ListViewActions,
    Content: ListViewContent,
    ContentItem: ListViewContentItem,
    Label: ListViewContentItemTitle,
    Value: ListViewContentItemDescription,
    LeftAction: ListViewLeftActions
};

export { ListView };